import { Info } from "lucide-react";
import { type ReactNode, useState } from "react";

import { Modal } from "../components/Modal";

/**
 * A page's explanation of itself, behind an ⓘ beside its title. The page
 * stays controls-first; the prose opens in a dialog when asked for.
 */
export function HowItWorks({ title = "How this works", children }: { title?: string; children: ReactNode }) {
	const [open, setOpen] = useState(false);
	return (
		<>
			<button
				type="button"
				onClick={() => setOpen(true)}
				aria-label={title}
				title={title}
				className="inline-flex size-7 items-center justify-center rounded-full align-middle text-muted hover:bg-raised hover:text-ink"
			>
				<Info className="size-4" aria-hidden />
			</button>
			<Modal open={open} onClose={() => setOpen(false)} title={title} size="md">
				<div className="flex flex-col gap-2.5 px-4 py-3 text-[13px] leading-relaxed text-muted">{children}</div>
			</Modal>
		</>
	);
}

/** One point in a HowItWorks: a short lead in ink, then the explanation. */
export function Point({ lead, children }: { lead: string; children: ReactNode }) {
	return (
		<p>
			<span className="font-medium text-ink">{lead}</span> {children}
		</p>
	);
}
